export const removeItemAtIndex = function<T>(input: T[], index: number): T[] {
  input.splice(index, 1);
  return input;
};
